(function () {


    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('geocoding-data', {
            url: "/:langcode/address-validation",
            templateUrl: 'app/geocoding/geocoding.html',
            controller: 'GeocodingController',
            params: {
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'geocoding');
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('address_validation');
                    return $translate.refresh();
                }]
            }

        });
    }]);

})();
